import { Button, Typography } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";
import WelcomeImage from "../../Assets/Images/001.jpg";

const { Title } = Typography;

export const WelcomePage = () => {
  const history = useHistory();

  return (
    <div className="rowSec">
      <div className="colSec onBoardingLeft">
        <img src={WelcomeImage} alt="" className="" />
      </div>
      <div className="colSec onBoardingRight">
        <div className="step_1">
          <Title level={2}>Get Started with SanAttest</Title>
          <h5>
            A digital solution that aids businesses in the fight against the
            spread of deadly diseases, ready for immediate use.
          </h5>
          <div className="buttonSec">
            <Button
              type="primary"
              shape="round"
              size="large"
              className="mr-4"
              onClick={() => history.push("/signup")}
            >
              Start Now
            </Button>
            <Button shape="round"
              size="large" onClick={() => history.push("/login")}>
              Login
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
